import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import placeholder from "../../assets/images/fashion/product/12.jpg";
import { currencyFormat } from "../../utils/currencyFormater";
import { useDispatch } from "react-redux";
import {
  getHighDemadItems,
  updateHighDemandPrice,
} from "../../reducers/adminReducers";
import { toast } from "react-toastify";
const ListDatatable = ({ id, myData, myClass }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  useEffect(() => {
    setData(myData);
  }, [myData]);
  const columnDefs = [
    {
      name: "Image",
      cell: (row) => <ProfileImage row={row} />,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Market Demand",
      selector: (row) => row?.count,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => currencyFormat(row?.price),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <ActionButton handleUpdatePrice={handleUpdatePrice} data={row} />
      ),
    },
  ];

  const handleUpdatePrice = (data) => {
    const payload = {
      assestId: data?.assetId,
      updatedPrice: data?.updatedPrice
    }
    dispatch(updateHighDemandPrice(payload)).then((response) => {
      if (response?.payload?.resultData?.data?.code === 200) {
        toast.success("Price Updated Successfuly", { toastId: "updated" });
        dispatch(getHighDemadItems());
      } else {
        toast.error("Something Went Wrong to Update", { toastId: "wentWrong" });
      }
    });
  };

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};
const ProfileImage = ({ row }) => {
  return (
    <div className="profile-image">
      <img src={row.bannerImage ? row.bannerImage : placeholder} alt="logo" />
    </div>
  );
};

const ActionButton = ({ handleUpdatePrice, data }) => {
  return (
    <div className="action-btn">
      <button
        onClick={() => handleUpdatePrice(data)}
        className={`btn ${
          data?.updatedPrice ? "btn-secondary" : "btn-primary"
        }`}>
        {data?.updatedPrice ? "Revert Price" : "Update Price"}
      </button>
    </div>
  );
};
export default ListDatatable;
